import { render, staticRenderFns } from "./ContactAddressEdit.vue?vue&type=template&id=539cdd02&"
import script from "./ContactAddressEdit.vue?vue&type=script&lang=js&"
export * from "./ContactAddressEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports